<app-error-message [errorMessage]="error"></app-error-message>
<div class="card">
    <div class="card-body px-0 pb-0 economy-supplier-invoice">
        <form [formGroup]="fg">
            <div class="px-3 pb-2" fxLayout="column" fxLayout.gt-md="row" fxLayoutGap="2%">
                <div fxFlex="20%" fxLayoutAlign="start start" fxLayout="column">
                    <div>
                        <span class="heading">{{getDisplayState() | translate}}: {{supplierInvoice.invoiceNumber}}</span>
                        <app-open-invoice-pdf [invoiceDocumentId]="supplierInvoice.invoiceDocumentId"
                                              *ngIf="supplierInvoice.invoiceDocumentId">
                        </app-open-invoice-pdf>
                    </div>
                    <div class="invoice-status" *ngIf="supplierInvoice.invoiceStatus">
                        {{'Status' | translate}}: {{ supplierInvoice.invoiceStatus | translate }}
                    </div>
                    <div class="invoice-submitted-by" *ngIf="supplierInvoice.submittedByInSupo">
                        {{'Submitted by' | translate}}: {{ supplierInvoice.submittedByInSupo }}
                    </div>
                    <div class="invoice-submitted-date" *ngIf="supplierInvoice.receivedDate">
                        {{'Submitted on' | translate}}: {{ supplierInvoice.receivedDate | date: 'dd/MM/yyyy' }}
                    </div>
                </div>

                <div fxFlex="78%" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="end start" fxLayoutGap="20px">
                    <div fxFlex="470px" fxFlex.lt-md="300px" fxFlex.lt-sm="50px">
                        <span class="name">{{'Creditor' | translate}}<span class="required">*</span></span>
                        <div class="common-drop-down common-drop-down-arrow drop-down-input"
                            [className]="fg.get('creditorId')?.invalid ? 'invalid-drop-down-input' : 'drop-down-input'">
                            <ng-select class="custom" [items]="dropDownSuppliers" bindLabel="name"
                                bindValue="id" [clearable]="false" formControlName="creditorId"></ng-select>
                        </div>
                        <div *ngIf="getDisplayState() === 'New'" class="pt-2">
                            <div fxLayout="row" fxLayoutGap="4%">
                                <div class="supplier-details" fxFlex="53%">
                                    <span class="label">IBAN:</span>
                                    <span class="text" *ngIf="supplierDetails && supplierDetails.iban">
                                        {{supplierDetails.iban}}
                                    </span>
                                </div>
                                <div class="supplier-details" fxFlex="43%">
                                    <span class="label">SWIFT:</span>
                                    <span class="text" *ngIf="supplierDetails && supplierDetails.swift">
                                        {{supplierDetails.swift}}
                                    </span>
                                </div>
                            </div>
                            <div fxLayout="row" fxLayoutGap="4%">
                                <div class="supplier-details" fxFlex="53%">
                                    <span class="label">Account:</span>
                                    <span class="text" *ngIf="supplierDetails && supplierDetails.bankAccount">
                                        {{supplierDetails.bankAccount}}
                                    </span>
                                </div>
                                <div class="supplier-details" fxFlex="43%">
                                    <span class="label">Terms:</span>
                                    <span class="text" *ngIf="supplierDetails && supplierDetails.paymentTermsT">
                                        {{supplierDetails.paymentTermsT}}
                                    </span>
                                </div>
                            </div>
                            <div fxLayout="row" fxLayoutGap="4%" *ngIf="isErpCreditorDisabled">
                              <div class="supplier-details">
                                <span class="label">Status:</span>
                                <span class="text text-red">Inactive. Please contact <a href="mailto: supplierportal@sos.eu">supplierportal&#64;sos.eu</a></span>
                              </div>
                            </div>
                        </div>
                    </div>
                    <div fxFlex="140px" fxFlex.lt-sm="50px">
                        <span class="name">{{'Invoice date' | translate}}<span class="required">*</span></span>
                        <app-input-date-picker formControlName="invoiceDate"
                                               [withImage]="true"
                                               [minDate]="getMinimumInvoiceDate()"
                                               [maxDate]="getMaximumInvoiceDate()"
                                               [invalid]="validationError('invoiceDate')">
                        </app-input-date-picker>
                        <div *ngIf="getDisplayState() === 'New'" class="pt-2">
                            <div fxLayout="row">
                                <div class="supplier-details">
                                    <span class="label">Estimated due date:</span>
                                </div>
                            </div>
                            <div fxLayout="row">
                                <div class="supplier-details">
                                    <span class="text">{{ estimatedDueDate ? (estimatedDueDate | date: 'longDate') : '&nbsp;' }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div fxFlex="140px" fxFlex.lt-sm="50px">
                        <span class="name">{{'Invoice no.' | translate}}<span class="required">*</span></span>
                        <input trimFormControlValue formControlName="invoiceNo" pattern="^[a-zA-Z0-9]+(.*[a-zA-Z0-9]+)?$" maxlength="50" (change)="checkInvoiceNo($event)" [class.invalid-input]="validationError('invoiceNo')">
                    </div>
                </div>
            </div>
            <div class="board-content">
                <div class="board-container">
                    <div class="primary-table-container">
                        <table class="primary-table">
                            <thead>
                                <tr>
                                    <td class="td-service">{{'Service' | translate}}</td>
                                    <td class="td-item">
                                        <div class="caselock-no-events">
                                            {{'Item' | translate}}
                                            <span>
                                                <div class="add-item-button" *ngIf="!isApproved()" (click)="addItem()">
                                                    <fa-icon icon="plus"></fa-icon> Add item
                                                </div>
                                            </span>
                                        </div>
                                    </td>
                                    <td class="td-quantity">{{'Quantity' | translate}}</td>
                                    <td class="td-unit">{{'Unit' | translate}}</td>
                                    <td class="td-savings-amount">{{'Savings amount' | translate}}</td>
                                    <td class="td-savings-pct">{{'Savings %' | translate}}</td>
                                    <td>{{'Amount' | translate}}</td>
                                </tr>
                            </thead>
                        </table>
                        <div class="supplier-invoice-details" id="scrollToMe">
                            <ng-container *ngFor="let item of items.controls; let i = index">
                                <app-supplier-invoice-item [showDelete]="i > 0" (delete)="deleteItem($event)"
                                    [localCurrency]="supplierInvoice.invoiceAmountLocal?.currency"
                                    [localAmount]="i === 0 ? supplierInvoice.invoiceAmountLocal?.amount : null"
                                    [serviceOrders]="serviceOrders"
                                    [caseStakeholders]="seccaCase?.caseStakeholders"
                                    [caseCreatedDate]="seccaCase?.caseCreatedDate"
                                    [isSupplierPartner]="isSupplierPartner"
                                    [isSupplierMedicalEscort]="isSupplierMedicalEscort"
                                    [isBatchBilling]="isBatchBilling"
                                    [isBatchBillingActive]="isBatchBillingActive"
                                    [hideSavingButtons]="isSupplierMedicalEscort"
                                    (serviceOrderChangeEvent)="serviceOrderChanged($event)"
                                    [formControl]="item">
                                </app-supplier-invoice-item>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>

            <div style="background-color: #e5e5e5;">
                <div class="px-2" fxLayout="row">
                    <div class="supplier-invoice-footer" fxLayoutAlign="start">
                        <div fxLayout="column" class="supplier-invoice-footer-column">
                            <div class="supplier-invoice-footer-box">
                                <div class="container-fluid box-table">
                                    <div fxLayout="row">
                                        <div fxFlex="200px" fxFlex.lt-lg="230px" fxLayoutAlign="start">{{'Gross amount' | translate }}</div>
                                        <div fxFlex="200px" fxLayoutAlign="end">
                                            {{ getTotalGrossAmount() | number: '.' +
                                            supplierInvoice.invoiceAmountLocal.precision :'da' }}
                                            <div class="supplier-invoice-footer-currency">{{
                                                supplierInvoice.invoiceAmountLocal.currency }}</div>
                                        </div>
                                    </div>
                                    <div fxLayout="row">
                                        <div fxFlex="50" fxLayoutAlign="start">{{'Gross saving' | translate }}</div>
                                        <div fxFlex="200px" fxLayoutAlign="end">
                                            <span class="supplier-invoice-footer-pct">({{getTotalGrossSavingsPct() | numberFormat}}%)</span>
                                            {{ getTotalGrossSavings() | number: '.' +
                                            supplierInvoice.invoiceAmountLocal.precision :'da' }}
                                            <div class="supplier-invoice-footer-currency">{{
                                                supplierInvoice.invoiceAmountLocal.currency }}</div>
                                        </div>
                                    </div>
                                    <div fxLayout="row">
                                        <div fxFlex="200px" fxFlex.lt-lg="230px" fxLayoutAlign="start">{{'Invoiced' | translate }}</div>
                                        <div fxFlex="200px" fxLayoutAlign="end">
                                            {{ getTotalPaidAmount() | number: '.' +
                                            supplierInvoice.invoiceAmountLocal.precision :'da' }}
                                            <div class="supplier-invoice-footer-currency">{{
                                                supplierInvoice.invoiceAmountLocal.currency }}</div>
                                        </div>
                                    </div>
                                    <div fxLayout="row">
                                        <div fxFlex="50" fxLayoutAlign="start">{{'Reduction' | translate }}</div>
                                        <div fxFlex="200px" fxLayoutAlign="end">
                                            <span class="supplier-invoice-footer-pct">({{getTotalReductionsPct() | numberFormat}}%)</span>
                                            {{ getTotalReductions() | number: '.' +
                                            supplierInvoice.invoiceAmountLocal.precision :'da' }}
                                            <div class="supplier-invoice-footer-currency">{{
                                                supplierInvoice.invoiceAmountLocal.currency }}</div>
                                        </div>
                                    </div>
                                    <div class="sum-line mx-0"></div>
                                    <div fxLayout="row">
                                        <div fxFlex="50" fxLayoutAlign="start">{{'Total paid amount' | translate }}
                                        </div>
                                        <div fxFlex="200px" fxLayoutAlign="end">
                                            {{ getTotalNetAmount() | number: '.' +
                                            supplierInvoice.invoiceAmountLocal.precision :'da' }}
                                            <div class="supplier-invoice-footer-currency">{{
                                                supplierInvoice.invoiceAmountLocal.currency }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="state === 'draft'; then fileUpload else displayReductionRemark"></div>
                      <ng-template #fileUpload>
                        <div fxFlex="100" fxLayout="row" fxLayoutAlign="center" class="px-2">
                          <div class="file-upload px-2">
                              <div [class.hidden]="!!supplierInvoice.invoiceDocument">
                                <div *ngIf="isMedicalEscortSelected" class="upload-title">
                                  {{'Invoice your fee' | translate}}<span class="required">*</span>
                                </div>
                                <div *ngIf="!isMedicalEscortSelected" class="upload-title">
                                  {{'Invoice' | translate}}<span class="required">*</span>
                                </div>
                                <div>
                                    <app-upload #uploadComponentInstance [allowOnlyPdf]="true" [multiple]="false" (onFileChange)="onInvoiceFileSelected()"></app-upload>
                                    <span *ngIf="uploadComponentInstance.files.length > 1">{{'Only one invoice document is accepted' | translate}}</span>
                                    <div class="file-error" *ngIf="invalidInvoiceFiles?.length > 0">{{'Invalid file' | translate: { invalidFile: getFilename(invalidInvoiceFiles) } }}</div>
                                    <div class="file-error-types" *ngIf="invalidInvoiceFiles?.length > 0">{{'Accepted file types' | translate: { supportedFileTypes: allowedFileTypesInvoiceFiles } }}</div>
                                    <div class="file-error" *ngIf="maxSizeExceededInvoiceFiles?.length > 0">{{'Max size exceeded file' | translate: { maxSize: maxSizeInvoiceFiles, invalidFile: getFilename(maxSizeExceededInvoiceFiles) } }}</div>
                                </div>
                              </div>
                              <table class="primary-table" [class.hidden]="!supplierInvoice.invoiceDocument">
                                  <thead>
                                      <tr>
                                          <td colspan="2">{{'Invoice file name' | translate}}</td>
                                      </tr>
                                  </thead>
                                  <tbody>
                                      <tr>
                                          <td class="view"><a
                                                  (click)="getAndOpenDocument(supplierInvoice.invoiceDocument)">{{supplierInvoice.invoiceDocument?.name}}</a>
                                          </td>
                                          <td class="delete">
                                              <fa-icon class="delete" icon="trash" (click)="deleteDocument()"></fa-icon>
                                          </td>
                                      </tr>
                                  </tbody>
                              </table>
                              <span
                                  *ngIf="isSubmitRequest && !supplierInvoice.invoiceDocument && !uploadComponentInstance.files?.length">
                                  {{'Invoice document is required' | translate}}
                              </span>
                          </div>

                          <div class="file-upload px-2" *ngIf="isMedicalEscortSelected || supplierInvoice.travelAndExpensesDocuments?.length > 0">
                            <div [class.hidden]="supplierInvoice.travelAndExpensesDocuments?.length > 0">
                              <div class="upload-title">
                                {{'Travel and expenses documentation' | translate}}<span class="required">*</span>
                              </div>
                              <div>
                                  <app-upload #uploadTravelExpensesComponentInstance [accept]="getAcceptedTravelAndExpensesDocumentTypes()" [maxFiles]="maxTravelAndExpensesDocuments" (onFileChange)="onTravelAndExpenseFileSelected()"></app-upload>
                                  <span *ngIf="uploadTravelExpensesComponentInstance.files.length >= maxTravelAndExpensesDocuments">{{'Max travel and expenses documents exceeded' | translate: { max: maxTravelAndExpensesDocuments} }}</span>
                                  <div class="file-error" *ngIf="invalidTravelAndExpenseFiles?.length > 0">{{'Invalid file' | translate: { invalidFile: getFilename(invalidTravelAndExpenseFiles) } }}</div>
                                  <div class="file-error-types" *ngIf="invalidTravelAndExpenseFiles?.length > 0">{{'Accepted file types' | translate: { supportedFileTypes: allowedFileTypesTravelAndExpenseFiles } }}</div>
                                  <div class="file-error" *ngIf="maxSizeExceededTravelAndExpenseFiles?.length > 0">{{'Max size exceeded file' | translate: { maxSize: maxSizeTravelAndExpenseFiles, invalidFile: getFilename(maxSizeExceededTravelAndExpenseFiles) } }}</div>
                              </div>
                            </div>
                            <table class="primary-table" [class.hidden]="!supplierInvoice.travelAndExpensesDocuments || supplierInvoice.travelAndExpensesDocuments?.length === 0">
                                <thead>
                                    <tr>
                                        <td colspan="2">{{'Travel and expenses file name' | translate}}</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let travelAndExpensesDocument of supplierInvoice.travelAndExpensesDocuments">
                                        <td class="view"><a
                                                (click)="getAndOpenDocument(travelAndExpensesDocument)">{{travelAndExpensesDocument.name}}</a>
                                        </td>
                                        <td class="delete">
                                            <fa-icon class="delete" icon="trash" (click)="deleteTravelAndExpensesDocument(travelAndExpensesDocument.id)"></fa-icon>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <span
                                *ngIf="isSubmitRequest && supplierInvoice.travelAndExpensesDocuments?.length === 0 && uploadTravelExpensesComponentInstance.files?.length === 0">
                                {{'Travel and expenses documents are required' | translate}}
                            </span>
                          </div>

                          <div class="file-upload px-2" *ngIf="isMedicalEscortSelected || supplierInvoice.medicalTravelReportDocument">
                            <div [class.hidden]="!!supplierInvoice.medicalTravelReportDocument">
                              <div class="upload-title">
                                {{'Medical travel report' | translate}}<span class="required">*</span>
                              </div>
                              <div>
                                  <app-upload #uploadMedicalTravelComponentInstance [allowOnlyPdf]="true" [multiple]="false" (onFileChange)="onMedicalTravelReportFileSelected()"></app-upload>
                                  <span *ngIf="uploadMedicalTravelComponentInstance.files.length > 1">{{'Only one medical travel report document is accepted' | translate}}</span>
                                  <div class="file-error" *ngIf="invalidMedicalTravelReportFiles?.length > 0">{{'Invalid file' | translate: { invalidFile: getFilename(invalidMedicalTravelReportFiles) } }}</div>
                                  <div class="file-error-types" *ngIf="invalidMedicalTravelReportFiles?.length > 0">{{'Accepted file types' | translate: { supportedFileTypes: allowedFileTypesMedicalTravelReportFiles } }}</div>
                                  <div class="file-error" *ngIf="maxSizeExceededMedicalTravelReportFiles?.length > 0">{{'Max size exceeded file' | translate: { maxSize: maxSizeMedicalTravelReportFiles, invalidFile: getFilename(maxSizeExceededMedicalTravelReportFiles) } }}</div>
                              </div>
                            </div>
                            <table class="primary-table" [class.hidden]="!supplierInvoice.medicalTravelReportDocument">
                                <thead>
                                    <tr>
                                        <td colspan="2">{{'Medical travel report File name' | translate}}</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="view"><a
                                                (click)="getAndOpenDocument(supplierInvoice.medicalTravelReportDocument)">{{supplierInvoice.medicalTravelReportDocument?.name}}</a>
                                        </td>
                                        <td class="delete">
                                            <fa-icon class="delete" icon="trash" (click)="deleteMedicalTravelReportDocument()"></fa-icon>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <span
                              *ngIf="isSubmitRequest && !supplierInvoice.medicalTravelReportDocument && !uploadMedicalTravelComponentInstance.files?.length">
                              {{'Medical travel report document is required' | translate}}
                            </span>
                          </div>
                      </div>
                     </ng-template>

                     <ng-template #displayReductionRemark>
                        <div fxFlex="50">
                            <div class="reduction-remark">
                                <span>{{'Reduction remark' | translate}}</span>
                                <textarea disabled rows="4">{{supplierInvoice.reductionRemark}}</textarea>
                            </div>
                        </div>
                     </ng-template>

                    <div fxFlex="0 0 24" fxLayoutAlign="end end">
                        <div fxFlex="100" fxLayout="column">
                            <div *ngIf="error404" class="mat-error py-2" fxLayout="row" fxLayoutAlign="end">
                                {{'The creditor is not found in our Finance system. It will not be possible to submit your invoice, but it still possible to save a draft. Please contact supplierportal@sos.eu to get more info about the creditor.' | translate}}
                            </div>
                            <div *ngIf="error503" class="mat-error py-2" fxLayout="row" fxLayoutAlign="end">
                                {{'Our Finance system is temporally out of service. It will not be possible to submit your invoice at this moment. It is still possible to save a draft and submit it later. We apologise for the inconvenience. If you have any questions please contact supplierportal@sos.eu.' | translate}}
                            </div>
                            <div class="py-2" fxLayout="row" fxLayoutAlign="end">
                                <app-form-error-message [form]="fg"></app-form-error-message>
                            </div>
                            <div class="py-2" fxLayout="row" fxLayoutAlign="end"
                                *ngIf="state === 'draft' && invoiceNoUsedMsg">
                                <div fxLayout="column" fxLayoutAlign="end" fxFlex="0 1 67">
                                    <mat-error _ngcontent-lno-c503="" role="alert" class="mat-error">
                                        {{invoiceNoUsedMsg | translate:{'max':50} }}
                                    </mat-error>
                                </div>
                            </div>
                            <div *ngIf="isMedicalEscortAndMultipleItems()" class="mat-error py-2" fxLayout="row" fxLayoutAlign="end">
                              {{'Only one serviceorder type is allowed for medicalEscort' | translate}}
                            </div>
                            <div *ngIf="invoiceNoLookupInProgress" class="py-2" fxLayout="row" fxLayoutAlign="end">
                              <div>{{'Checking invoice no' | translate}} &nbsp;&nbsp;</div>
                              <div><app-spinner [noPadding]="true"></app-spinner></div>
                            </div>
                            <div class="py-2" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="end">
                                <button class="me-2"
                                        mat-stroked-button
                                        type="button"
                                        [disabled]="saveInProgress"
                                        (click)="cancel()"                                        >
                                    {{ (state === 'draft' || isAmendingFinanceBridgeError() ? 'Cancel' : 'Close') | translate }}
                                </button>
                                <button class="draft me-2"
                                        mat-stroked-button
                                        type="button"
                                        [disabled]="saveInProgress"
                                        (click)="delete()"
                                        *ngIf="isAuthenticated() && isDraft && supplierInvoice.id">
                                    {{ 'Delete' | translate }}
                                </button>
                                <span [disablePopover]="isSaveDraftButtonPopoverDisabled()" triggers="hover" [ngbPopover]="popContentSaveDraftButton" container="body">
                                  <ng-template #popContentSaveDraftButton><span [innerHTML]="getSaveDraftButtonDisabledText() | safeHtml"></span></ng-template>
                                  <button class="draft me-2"
                                          mat-stroked-button
                                          type="button"
                                          [disabled]="saveDisabled()"
                                          (click)="save()"
                                          *ngIf="isAuthenticated() && isDraft && !isBatchBilling"
                                          >
                                    {{'Save draft' | translate}}
                                  </button>
                                </span>
                                <span [disablePopover]="isSubmitButtonPopoverDisabled()" triggers="hover" [ngbPopover]="popContentSubmitButton" container="body">
                                  <ng-template #popContentSubmitButton><span [innerHTML]="getSubmitButtonDisabledText() | safeHtml"></span></ng-template>
                                  <button class="primary"
                                          mat-stroked-button
                                          type="button"
                                          *ngIf="(isDraft && !isBatchBilling) || isSupoInvoiceFinanceBridgeError"
                                          [disabled]="submitDisabled()"
                                          (click)="submitInvoice()">
                                    {{'Submit' | translate}}
                                  </button>
                                </span>
                                <span [disablePopover]="isSubmitButtonPopoverDisabled()" triggers="hover" [ngbPopover]="popContentSubmitButton" container="body">
                                  <ng-template #popContentSubmitButton><span [innerHTML]="getSubmitButtonDisabledText() | safeHtml"></span></ng-template>
                                  <button class="primary"
                                          mat-stroked-button
                                          type="button"
                                          *ngIf="isDraft && isBatchBilling"
                                          [disabled]="submitDisabled()"
                                          (click)="submitCaseAndInvoice()">
                                    {{'Submit case and invoice' | translate}}
                                  </button>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
<div *ngIf="saveInProgress && !error" class="spinner-overlay d-flex justify-content-center">
  <div class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
<ng-container *ngIf="otherInvoicesOnCase && !isBatchBilling">
    <h2 class="pt-4 pb-1">{{ 'Other invoices on case' | translate }}</h2>
    <div class="board-content">
        <div class="board-container">
            <div class="primary-table-container">
                <table class="primary-table table-with-grouped-rows">
                    <thead>
                    <tr>
                        <td (click)="sortBy('invoiceNo')"
                            [ngClass]="['sortable', sortedBy('invoiceNo')]" fxHide="true" fxShow.gt-xs>
                            {{ 'Invoice number' | translate }}
                        </td>
                        <td (click)="sortBy('invoiceDate')"
                            [ngClass]="['sortable', sortedBy('invoiceDate')]">
                            {{ 'Invoice date' | translate }}
                        </td>
                        <td (click)="sortBy('receivedDate')"
                            [ngClass]="['sortable', sortedBy('receivedDate')]" fxHide="true" fxShow.gt-md>
                            {{ 'Received date' | translate }}
                        </td>
                        <td (click)="sortBy('dueDate')"
                            [ngClass]="['sortable', sortedBy('dueDate')]" fxHide="true" fxShow.gt-md>
                            {{ 'Due date' | translate }}
                        </td>
                        <td (click)="sortBy('creditorId')"
                            [ngClass]="['sortable', sortedBy('creditorId')]" fxHide="true" fxShow.gt-md>
                            {{ 'Creditor' | translate }}
                        </td>
                        <td (click)="sortBy('currency')"
                            [ngClass]="['sortable', sortedBy('currency')]">
                            {{ 'Currency' | translate }}
                        </td>
                        <td (click)="sortBy('invoiceAmountLocal')"
                            [ngClass]="['sortable', sortedBy('invoiceAmountLocal')]">
                            {{ 'Original' | translate }}
                        </td>
                        <td (click)="sortBy('settled')"
                            [ngClass]="['sortable', sortedBy('settled')]" fxHide="true" fxShow.gt-md>
                            {{ 'Settled' | translate }}
                        </td>
                        <td (click)="sortBy('status')"
                            [ngClass]="['sortable', sortedBy('status')]" fxHide="true" fxShow.gt-md>
                            {{ 'Status' | translate }}
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let invoice of otherInvoicesOnCase; index as i">
                            <tr [ngClass]="{'even': isEven(i), 'odd': isOdd(i)}">
                                <td fxHide="true" fxShow.gt-xs>
                                    {{ invoice.invoiceNumber }}
                                    <app-open-invoice-pdf *ngIf="invoice.invoiceDocumentId"
                                                          [invoiceDocumentId]="invoice.invoiceDocumentId">
                                    </app-open-invoice-pdf>
                                </td>
                                <td>{{ invoice.invoiceDate | date: 'dd MMM yyyy' }}</td>
                                <td fxHide="true" fxShow.gt-md>{{ invoice.receivedDate | date: 'dd MMM yyyy' }}</td>
                                <td fxHide="true" fxShow.gt-md>{{ invoice.dueDate | date: 'dd MMM yyyy' }}</td>
                                <td fxHide="true" fxShow.gt-md>{{ invoice.creditorId}} {{invoice.creditorName }}</td>
                                <td>{{ invoice.invoiceAmountLocal.currency }}</td>
                                <td>{{ invoice.invoiceAmountLocal.amount | number:'2.2-2':'da'}}</td>
                                <td fxHide="true" fxShow.gt-md><div>{{ invoice.settled | number:'2.2-2':'da' }}</div></td>
                                <td fxHide="true" fxShow.gt-md>{{ getSimplifiedStatus(invoice) | translate }}</td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="!otherInvoicesOnCase && !isBatchBilling">
    <h3 class="pt-4">{{ 'There are no other invoices on the case' | translate }}</h3>
</ng-container>
